import { createContext, FC, ReactNode, useCallback, useMemo } from "react";
import { IntlFormatters, useIntl } from "react-intl";

import fr from "./texts/fr-FR.ts";

export type ReactIntlValuesType = Parameters<IntlFormatters<ReactNode>["formatMessage"]>[1];
export type LocaleKeysRecord = typeof fr;
export type LocaleKeys = keyof LocaleKeysRecord;

export type TranslateFunction = (id: LocaleKeys, values?: ReactIntlValuesType) => string;

export type CustomIntlContextValue<T = string> = {
  t: (id: T, values?: ReactIntlValuesType) => string;
};

export const CustomIntlContext = createContext<CustomIntlContextValue<LocaleKeys>>({
  t: () => "",
});

export const CustomIntlProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const intl = useIntl();

  const t = useCallback(
    (id: LocaleKeys, values?: ReactIntlValuesType) => {
      const messageDescriptor = { id: id as string, defaultMessage: id as string };
      const message = intl.formatMessage(messageDescriptor, values);
      const messageString = typeof message === "string" ? message : String(message);
      return messageString !== "" ? messageString : id;
    },
    [intl]
  );

  const contextValue = useMemo(() => ({ t }), [t]);

  return <CustomIntlContext.Provider value={contextValue}>{children}</CustomIntlContext.Provider>;
};
